import type { MechKey } from './keys';

export const bn: Partial<Record<MechKey, string>> = {
  'app.eyebrow': 'বলবিদ্যা · 2D',
  'panel.scene': 'দৃশ্য',
  'panel.dims': 'পরামিতি',
  'panel.style': 'রূপ',
  'panel.action': 'নিয়ন্ত্রণ',
  'style.body': 'বস্তু',
  'style.vector': 'ভেক্টর',
  'style.ground': 'মাটি',
  'style.forces': 'বল দেখান',
  'style.trace': 'পথ দেখান',
  'style.labels': 'ভেক্টর লেবেল',
  'hint.line1': 'শুরু করতে প্লে ক্লিক করুন · বস্তু টেনে সরান',
  'hint.line2': 'স্যান্ডবক্স: একটি আকার বেছে নিন, তারপর রাখতে ক্লিক করুন',
  'scene.incline': 'আনত তল',
  'scene.projectile': 'প্রাস গতি',
  'scene.pendulum': 'দোলক',
  'scene.springMass': 'স্প্রিং-ভর তন্ত্র',
  'scene.collisions': 'সংঘর্ষ',
  'scene.atwood': 'অ্যাটউড যন্ত্র',
  'scene.circular': 'বৃত্তাকার গতি',
  'scene.sandbox': 'স্যান্ডবক্স',
  'dim.angle': 'কোণ (°)',
  'dim.friction': 'ঘর্ষণ',
  'dim.mass': 'ভর',
  'dim.massA': 'ভর A',
  'dim.massB': 'ভর B',
  'dim.velocity': 'বেগ',
  'dim.angleLaunch': 'উৎক্ষেপণ কোণ (°)',
  'dim.gravity': 'মাধ্যাকর্ষণ',
  'dim.gravityX': 'মাধ্যাকর্ষণ x',
  'dim.gravityY': 'মাধ্যাকর্ষণ y',
  'dim.length': 'দৈর্ঘ্য',
  'dim.damping': 'অবমন্দন',
  'dim.spring': 'দৃঢ়তা',
  'dim.restitution': 'পুনরুদ্ধার',
  'dim.radius': 'ব্যাসার্ধ',
  'dim.speed': 'দ্রুতি',
  'action.play': 'চালান',
  'action.pause': 'বিরতি',
  'action.step': 'ধাপ',
  'action.reset': 'রিসেট',
  'action.speed': 'গতি',
  'action.clear': 'মুছুন',
  'force.gravity': 'Fg',
  'force.normal': 'N',
  'force.friction': 'Ff',
  'force.tension': 'T',
  'force.spring': 'Fs',
  'force.applied': 'Fa',
  'force.air': 'Fd',
  'forceName.gravity': 'মাধ্যাকর্ষণ',
  'forceName.normal': 'অভিলম্ব বল',
  'forceName.friction': 'ঘর্ষণ বল',
  'forceName.tension': 'টান',
  'forceName.spring': 'স্প্রিং বল',
  'forceName.applied': 'প্রযুক্ত বল',
  'forceName.air': 'বায়ু প্রতিরোধ',
  'palette.box': 'বাক্স',
  'palette.circle': 'বল',
  'palette.ramp': 'ঢাল',
  'palette.ground': 'মাটি',
  'palette.hint': 'একটি আকার বেছে নিন, তারপর রাখতে ক্যানভাসে ক্লিক করুন।',
  'panel.forces': 'পর্যবেক্ষিত বল',
  'forces.empty': 'এখনও কিছু নেই — দৃশ্য চালান',
};
